const glass = [
    { name: '4-14-4', glasgoot: 30 },
    { name: '4-6-4', glasgoot: 26 },
    { name: '4-9-4', glasgoot: 26 },
    { name: '4-12-4', glasgoot: 26 },
    { name: '4-13-4', glasgoot: 26 },
    { name: '4-15-4', glasgoot: 30 },
    { name: '4-12-5', glasgoot: 26 },
    { name: '4-9-5', glasgoot: 26 },
    { name: '4-15-5', glasgoot: 30 },
    { name: '33.1-9-33.1', glasgoot: 26 },
    { name: '33.1-12-33.1', glasgoot: 30 },
    { name: '33.1-15-33.1', glasgoot: 34 },
    { name: '4-9-33.1', glasgoot: 26 },
    { name: '4-12-33.1', glasgoot: 30 },
    { name: '4-15-33.1', glasgoot: 30 },
    { name: '4-12-33.1M.F.', glasgoot: 30 },
    { name: '33.1-12-Canale Mat', glasgoot: 30 },
    { name: '33.1-12-Crepi', glasgoot: 30 },
    { name: '4-12-Crepi', glasgoot: 26 }
];

export default glass


// WEBPACK FOOTER //
// ./src/data/glass.js